/**
 * Sidebar collapse store — пользовательское сворачивание навигации
 * (DESKTOP ≥1024px; на планшете sidebar всегда иконочный, коллапс игнорируется).
 * Состояние сохраняется в localStorage, SSR-безопасно (initial = false).
 */

import { writable, get } from 'svelte/store'

const STORAGE_KEY = 'bm-sidebar-collapsed'

function getInitialCollapsed(): boolean {
  if (typeof localStorage !== 'undefined') {
    return localStorage.getItem(STORAGE_KEY) === '1'
  }
  return false
}

export const sidebarCollapsed = writable<boolean>(getInitialCollapsed())

/** Вызывается из +layout onMount: класс на .app-shell + персист. */
export function setSidebarCollapsed(collapsed: boolean): void {
  sidebarCollapsed.set(collapsed)
  try {
    localStorage.setItem(STORAGE_KEY, collapsed ? '1' : '0')
  } catch {
    // private mode — ignore
  }
}

export function toggleSidebar(): void {
  setSidebarCollapsed(!get(sidebarCollapsed))
}
